/** Catalog / course-card primary action for a signed-in student. */
export type CatalogCourseCta = "continue" | "view";

export function catalogCourseCta(isEnrolled: boolean): CatalogCourseCta {
  return isEnrolled ? "continue" : "view";
}

export function catalogCourseHref(
  tenantSlug: string,
  courseSlug: string,
  cta: CatalogCourseCta,
): string {
  if (cta === "continue") {
    return `/t/${tenantSlug}/learn/${courseSlug}`;
  }
  return `/t/${tenantSlug}/courses/${courseSlug}`;
}
